function manageSearchTabs(){
    // Select tab buttons and tab content containers
    const tabButtons = document.querySelectorAll('.tab-item-button');
    const tabContents = document.querySelectorAll('.video-tab-content');
  
    // Add click event listeners to each tab button
    tabButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        // Remove active class from all buttons and hide all tab contents
        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabContents.forEach(content => content.style.display = 'none');
  
        // Add active class to the clicked button
        button.classList.add('active');
  
        // Show the corresponding tab content
        tabContents[index].style.display = 'flex';
      });
    });
  
    // Initialize the first tab as active
    tabButtons[0].classList.add('active');
    tabContents[0].style.display = 'flex';
  }
  manageSearchTabs();
  
  
  $(document).ready(function() {
    $(".search_filer_select").not('#homeThicknessFilter, #homeWidthFilter, #homeLengthFilter').select2({
      dropdownPosition: 'below'
    });
  
    /*-----------Loading Widget------------*/
    
    function loadFacetSppiner(isLoading = false) {
      var loadingCont = document.querySelector('.search_filter_item_ot');
      if(loadingCont) {
        isLoading === true ? (
            loadingCont.classList.add("disabled_search")
        ) : (
            loadingCont.classList.remove("disabled_search")
        )
      }
    }
  
    /*-----------End Loding Widget------------*/
  
    /*---------------Making Year Field-----------------*/
  
    const API_BASE_URL = "https://pgfilters.pgiproduct.com";
    const API_BASE_URL_NEW = "https://pureflow.pgiproduct.com";
    const API_PRODUCT_BASE_URL = "https://pureflow.pgiproduct.com/api/v1/getProducts";
    const NEW_BASE_URL = API_BASE_URL;
    
    var formData = new FormData();
    fetch(`${API_BASE_URL_NEW}/yearCollection/2`, {
      method: "GET",
    }).then(response => {
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return response.json();
      
    }).then(api => {
        var optData = api;
        optData.forEach((item, index) => {
          $('#searchYearSelect').append('<option>'+item.year+'</option>');
        });
      
    }).catch(error => console.error('Error: ', error));
  
    
    $('body').on('change', '#searchYearSelect', function() {
      var yearSelVal = $(this).val();
      if (!yearSelVal) {
        return;
      }
      loadFacetSppiner(true);
      $('#searchMakeSelect').children('option:not(:first)').remove();
      $('#searchModalSelect').children('option:not(:first)').remove();
      $('#searchMakeSelect, #searchModalSelect').val('').trigger('change');
      fetch(`${NEW_BASE_URL}/makeCollection/2/${yearSelVal}`, {
        method: "GET", 
      }).then(response => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
        
      }).then(api => {
          var optData = api;
          optData.forEach((item, index) => {
            let optValue = `${item.MakeID}_${item.make}`;
            $('#searchMakeSelect').append(`<option value="${optValue}">${item.make}</option>`);
          });
          $('#searchMakeSelect').val('').trigger('change');
          loadFacetSppiner(false);
          setTimeout(function () {
            var $make = $('#searchMakeSelect');
            if ($make.data('select2')) {
              $make.select2('open');
            }
          }, 0);
      }).catch(function (error) {
        console.error('Error: ', error);
        loadFacetSppiner(false);
      });
    });
    
    $('body').on('change', '#searchMakeSelect', function() {
      var makeSelVal = $(this).val();
      if (!makeSelVal) {
        $('#searchModalSelect').children('option:not(:first)').remove();
        $('#searchModalSelect').val('').trigger('change');
        return;
      }
      loadFacetSppiner(true);
      $('#searchModalSelect').children('option:not(:first)').remove();
      $('#searchModalSelect').val('').trigger('change');
      var parts = makeSelVal.split("_");
      var makeid = parts[0];
      var selectedYear = $('#searchYearSelect').val();
      fetch(`${NEW_BASE_URL}/modelCollection/2/${selectedYear}/${makeid}`, {
        method: "GET",
      }).then(response => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
        
      }).then(api => {
          var optData = api;
          optData.forEach((item, index) => {
            let optValue = `${item.BaseVehicleID}_${item.model}`;
            $('#searchModalSelect').append(`<option value="${optValue}">${item.model}</option>`);
          });
          $('#searchModalSelect').val('').trigger('change');
        setTimeout(function () {
          loadFacetSppiner(false);
          var $model = $('#searchModalSelect');
          if ($model.data('select2')) {
            $model.select2('open');
          }
        }, 200);
      }).catch(function (error) {
        console.error('Error: ', error);
        loadFacetSppiner(false);
      });
    });
  
    $('body').on('change', '#searchModalSelect', function() {
      var modal = $(this).val();
      if (!modal) {
        return;
      }
      loadFacetSppiner(true);
      var year = $('#searchYearSelect').val();
      var make = $('#searchMakeSelect').val();
      resolveCarFilterAndRedirect(year, make, modal);
    });
  
    function isFebrezePage() {
      return document.querySelector('.search-new-filter-main')?.getAttribute('data-page-type') === "febreze";
    }
  
    async function getAllQualifiers(url) {
      const response = await fetch(url, { method: "GET", mode: "cors" });
      return response.json();
    }
  
    async function resolveProductListUrl(baseVehicleId) {
      const getEngineData = await fetch(`${API_BASE_URL}/engineCollection/${baseVehicleId}`, {
        method: "GET",
        mode: "cors",
      }).then(function (r) { return r.json(); });
  
      if (getEngineData.length === 1) {
        const engineID = getEngineData[0].EngineConfigID;
        const allQualifiers = await getAllQualifiers(
          `${API_BASE_URL}/qualifierCollectionPureFlow/${baseVehicleId}/${engineID}/noqualifier/0/0`
        );
        if (allQualifiers?.name?.length === 1 && allQualifiers?.values?.length === 1) {
          return { productListUrl: `${API_BASE_URL_NEW}/productList1/${baseVehicleId}/${engineID}/noqualifier/noqualifier`, needsIntermediateSearch: false };
        }
        if (allQualifiers?.name?.length === 1 && allQualifiers?.values?.length > 1 && allQualifiers?.showdropdown === "true") {
          return { productListUrl: null, needsIntermediateSearch: true };
        }
        if (allQualifiers === "fail") {
          return { productListUrl: `${API_BASE_URL_NEW}/productList1/${baseVehicleId}/${engineID}/noqualifier/noqualifier`, needsIntermediateSearch: false };
        }
        return { productListUrl: null, needsIntermediateSearch: true };
      }
  
      const checkEngineData = await fetch(`${API_BASE_URL}/engineCheckPureFlow/${baseVehicleId}`, {
        method: "GET",
        mode: "cors",
      }).then(function (r) { return r.json(); });
      const showEngine = checkEngineData[checkEngineData.length - 1];
  
      if (showEngine.showdropdown === "false") {
        const engineID = getEngineData[0].EngineConfigID;
        const allQualifiers = await getAllQualifiers(
          `${API_BASE_URL}/qualifierCollectionPureFlow/${baseVehicleId}/${engineID}/noqualifier/0/0`
        );
        if (allQualifiers?.name?.length === 1 && allQualifiers?.values?.length === 1) {
          return { productListUrl: `${API_BASE_URL_NEW}/productList1/${baseVehicleId}/${engineID}/noqualifier/noqualifier`, needsIntermediateSearch: false };
        }
        if (allQualifiers?.name?.length === 1 && allQualifiers?.values?.length > 1 && allQualifiers?.showdropdown === "true") {
          return { productListUrl: null, needsIntermediateSearch: true };
        }
        if (allQualifiers === "fail") {
          return { productListUrl: `${API_BASE_URL_NEW}/productList1/${baseVehicleId}/${engineID}/noqualifier/noqualifier`, needsIntermediateSearch: false };
        }
        return { productListUrl: null, needsIntermediateSearch: true };
      }
  
      return { productListUrl: null, needsIntermediateSearch: true };
    }
  
    function redirectToHpSearch(year, make, model) {
      var febrezeQuery = isFebrezePage() ? "&brand=febreze" : "";
      window.location.href = `/search?hpSearch=tab:carFilter,teamYear:${year},termMake:${make},teamModel:${model}&homepageSearch${febrezeQuery}`;
    }
  
    function redirectCarFilterToNotAvailable(year, make, model) {
      localStorage.setItem("selectedModel", model || "");
      localStorage.setItem("selectedMake", make || "");
      localStorage.setItem("selectedYear", year || "");
      loadFacetSppiner(false);
      window.location.href = "/pages/not-available-in-pureflow";
    }

    async function redirectToCarResults(productListUrl, year, make, model) {
      const listResponse = await fetch(productListUrl, { method: "GET", mode: "cors" });
      if (!listResponse.ok) {
        throw new Error(`productList HTTP error! status: ${listResponse.status}`);
      }
      const apiRes = await listResponse.json();
  
      const filteredPartTypeArray = (apiRes.partTypeArray || []).filter(function (item) {
        const noteMatch = item?.note?.toLowerCase().includes("pureflow");
        const partNumberMatch = item?.partNumber?.toUpperCase().startsWith("RZ");
        return noteMatch || partNumberMatch;
      });
  
      if (filteredPartTypeArray.length === 1 && (filteredPartTypeArray[0].partNumber === "NRC" || filteredPartTypeArray[0].partNumber === "NR")) {
        loadFacetSppiner(false);
        window.location.href = "/pages/not-required";
        return;
      }
  
      if (filteredPartTypeArray.length === 0) {
        redirectCarFilterToNotAvailable(year, make, model);
        return;
      }
  
      const partNumbers = filteredPartTypeArray.map(function (item) { return item.partNumber; }).join(",");
      const tempMake = make.split("_");
      const tempModel = model.split("_");
  
      const formDataProduct = new FormData();
      formDataProduct.append("termYear", year || "");
      formDataProduct.append("termMake", tempMake[1] || make);
      formDataProduct.append("termModel", tempModel[1] || model);
      formDataProduct.append("partNumber", partNumbers);
      if (isFebrezePage()) {
        formDataProduct.append("brand", "febreze");
      }
  
      const productResponse = await fetch(API_PRODUCT_BASE_URL, {
        method: "POST",
        mode: "cors",
        body: formDataProduct,
      });
      if (!productResponse.ok) {
        throw new Error(`getProducts HTTP error! status: ${productResponse.status}`);
      }
      const productHandles = await productResponse.json();
  
      if (!productHandles.response || productHandles.response.length === 0) {
        redirectCarFilterToNotAvailable(year, make, model);
        return;
      }
  
      const handles = productHandles.response.map(function (product) { return product.handle; });
      const subQuery = `termYear:${year}|termMake:${make}|termModel:${model}`;
      const febrezeQuery = isFebrezePage() ? "&brand=febreze" : "";
      window.location.href = `/search?type=product&q=(handle:${handles.join(" OR handle:")})&filter=carair@advance-filter=${subQuery}${febrezeQuery}&sort_by=price-descending`;
    }
  
    async function resolveCarFilterAndRedirect(year, make, model) {
      Shopify?.analytics?.publish("on_car_filters", {
        vehicle_year: year,
        vehicle_make: make,
        vehicle_model: model
      });
  
      try {
        const baseVehicleId = model.split("_")[0];
        const resolved = await resolveProductListUrl(baseVehicleId);
  
        if (resolved.needsIntermediateSearch || !resolved.productListUrl) {
          redirectToHpSearch(year, make, model);
          return;
        }
  
        await redirectToCarResults(resolved.productListUrl, year, make, model);
      } catch (error) {
        console.error("Error resolving car filter:", error);
        redirectCarFilterToNotAvailable(year, make, model);
      }
    }
  
    function extractHandleFromProductUrl(url) {
      if (!url) return null;
      const match = String(url).match(/\/products\/([^/?#]+)/);
      return match ? match[1] : null;
    }
  
    async function redirectToHomeResults(width, length, height) {
      const searchQ = `hvac,Width_${width},Height_${length},Depth_${height}`;
      loadFacetSppiner(false);
      window.location.href = `/search?q=${encodeURIComponent(searchQ)}#hometab2`;
    }
  
    /*-----------------Home Filter Function (MCP collection filters, same as search)------------*/
  
    function homeFacetFilter(attempt) {
      attempt = attempt || 0;
      const $thickness = $('#homeThicknessFilter');
      if (!$thickness.length) {
        return;
      }
      if (!window.FACET_FILTER?.initHeroHomeFilters) {
        if (attempt < 40) {
          setTimeout(function() { homeFacetFilter(attempt + 1); }, 50);
        }
        return;
      }
  
      const heroFilterRoot = $thickness.closest('.search-new-filter-main')[0];
      if (heroFilterRoot?.dataset.homeFiltersReady === 'true') {
        return;
      }
      if (heroFilterRoot) {
        heroFilterRoot.dataset.homeFiltersReady = 'true';
      }
  
      window.FACET_FILTER.initHeroHomeFilters({
        root: heroFilterRoot || document,
        selectIds: {
          depth: 'homeThicknessFilter',
          width: 'homeWidthFilter',
          length: 'homeLengthFilter'
        },
        onLoading: function(isLoading) {
          loadFacetSppiner(isLoading === true);
        },
        onComplete: function(searchUrl) {
          const parts = (searchUrl.split('q=')[1] || '').split(',');
          Shopify?.analytics?.publish('on_home_filters', {
            filter_width: parts[1]?.replace('Width_', '') || '',
            filter_length: parts[2]?.replace('Height_', '') || '',
            filter_depth: parts[3]?.replace('Depth_', '') || ''
          });
          loadFacetSppiner(false);
          window.location.href = `${searchUrl}#hometab2`;
        }
      });
    }
    homeFacetFilter();
  });